import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/common';

export interface DocumentsEmptyStateProps {
  type: 'cv' | 'coverLetter';
}

export function DocumentsEmptyState({ type }: DocumentsEmptyStateProps) {
  const navigate = useNavigate();

  if (type === 'coverLetter') {
    return (
      <div className="documents-empty">
        <svg
          className="documents-empty__icon"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
        <h3 className="documents-empty__title">No cover letters yet</h3>
        <p className="documents-empty__description">
          Generate AI-tailored cover letters from any job in your pipeline.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 mt-4">
          <Button
            variant="primary"
            size="sm"
            onClick={() => navigate('/app/pipeline')}
          >
            Go to Pipeline
          </Button>
          <p className="text-xs text-text-secondary self-center">
            Open a job and use the Cover Letter section on the right
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="documents-empty">
      <svg
        className="documents-empty__icon"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
      <h3 className="documents-empty__title">No CVs generated yet</h3>
      <p className="documents-empty__description">
        You can generate a CV two ways:
      </p>
      <div className="flex flex-col sm:flex-row gap-3 mt-4">
        <Button
          variant="primary"
          size="sm"
          onClick={() => navigate('/app/pipeline')}
        >
          Go to Pipeline (job-specific CV)
        </Button>
        <p className="text-xs text-text-secondary self-center">
          or use the "Generate CV" button above for a general CV from your profile
        </p>
      </div>
    </div>
  );
}
